import {State} from '../types/state'
import {getFirstEvent} from './events'
import {isCalendarLayout} from './list-settings'
import {getComponentConfig} from './settings'

export const isItemOpened = (state: State, eventId: string) => state.layout.listItemOpened === eventId

export const getForcedRibbon = (state: State) => state.layout.forceShowRibbon

export const shouldForceShowRibbon = (state: State, event: wix.events.Event) =>
  !!getForcedRibbon(state) && (getFirstEvent(state)?.id === event.id || isCalendarLayout(getComponentConfig(state)))
